import React from 'react'
import { connect, ConnectedProps } from 'react-redux'

import { changeMoodMeterFormField } from 'page-modules/mood-meter/service/actions'
import MoodMeterChart from 'page-modules/mood-meter/charts/mood-meter-chart'
import { AppState } from 'common/store/reducer'
import { Mood } from 'page-modules/mood-meter/service/types'

const updateSliderValues = (slider: string, value: number) => {
  // @ts-expect-error - jQuery foundation call is not typed
  jQuery(slider).foundation('_setValues', jQuery(slider), value)
  // @ts-expect-error - jQuery foundation call is not typed
  jQuery(slider).foundation('setHandles')
}

const connector = connect(
  (state: AppState) => ({
    energyLevel: state.moodMeter.forms.plot.data.energy,
    pleasantnessLevel: state.moodMeter.forms.plot.data.pleasantness,
  }),
  (dispatch) => ({
    changeMoodMeterFormField: (key: string, value: number) =>
      dispatch(changeMoodMeterFormField(key, value)),
  }),
)

type Props = ConnectedProps<typeof connector>

class MoodSection extends React.Component<Props> {
  componentDidMount() {
    // @ts-expect-error - jQuery foundation call is not typed
    jQuery('.slider-pleasantness').foundation()
    jQuery('.slider-pleasantness').on('changed.zf.slider', (e: JQuery.TriggeredEvent) => {
      const sliderVal = parseInt(
        e.target.firstChild.attributes.getNamedItem('aria-valuenow').value,
        10,
      )
      this.props.changeMoodMeterFormField('pleasantness', sliderVal)
    })
    // @ts-expect-error - jQuery foundation call is not typed
    jQuery('.slider-energy').foundation()
    jQuery('.slider-energy').on('changed.zf.slider', (e: JQuery.TriggeredEvent) => {
      const sliderVal = parseInt(
        e.target.firstChild.attributes.getNamedItem('aria-valuenow').value,
        10,
      )
      this.props.changeMoodMeterFormField('energy', sliderVal)
    })
    document.addEventListener('keydown', this.handleKeyboardPlotting)
  }

  componentWillUnmount() {
    // @ts-expect-error - jQuery foundation call is not typed
    jQuery('.slider-pleasantness').foundation('_destroy')
    jQuery('.slider-pleasantness').off('changed.zf.slider')
    // @ts-expect-error - jQuery foundation call is not typed
    jQuery('.slider-energy').foundation('_destroy')
    jQuery('.slider-energy').off('changed.zf.slider')
    document.removeEventListener('keydown', this.handleKeyboardPlotting)
  }

  handleKeyboardPlotting = (event: KeyboardEvent) => {
    if (document.activeElement?.getAttribute('role') === 'slider') {
      return
    }
    const arrowKeyCodes = [37, 38, 39, 40]
    if (arrowKeyCodes.indexOf(event.keyCode) >= 0) {
      event.preventDefault() // We don't want to scroll the browser window
    }

    // Handle pleasantness
    if (event.keyCode === arrowKeyCodes[0]) {
      // Arrow left
      if (this.props.pleasantnessLevel === -5) return
      this.updatePleasantness(this.props.pleasantnessLevel - 1)
    }
    if (event.keyCode === arrowKeyCodes[2]) {
      // Arrow right
      if (this.props.pleasantnessLevel === 5) return
      this.updatePleasantness(this.props.pleasantnessLevel + 1)
    }

    // Handle energy
    if (event.keyCode === arrowKeyCodes[3]) {
      // Arrow down
      if (this.props.energyLevel === -5) return
      this.updateEnergy(this.props.energyLevel - 1)
    }
    if (event.keyCode === arrowKeyCodes[1]) {
      // Arrow up
      if (this.props.energyLevel === 5) return
      this.updateEnergy(this.props.energyLevel + 1)
    }
  }

  updateEnergy(energy: number) {
    updateSliderValues('.slider-energy', energy)
    this.props.changeMoodMeterFormField('energy', energy)
  }

  updatePleasantness(pleasantness: number) {
    updateSliderValues('.slider-pleasantness', pleasantness)
    this.props.changeMoodMeterFormField('pleasantness', pleasantness)
  }

  render() {
    return (
      <div className="mm-chart-container">
        <div className="mm-slider-container mm-slider-container-vertical">
          <div
            className="slider slider-energy vertical"
            data-slider
            data-vertical="true"
            data-start="-5"
            data-initial-start={this.props.energyLevel}
            data-end="5"
            data-step="1">
            <span
              className="slider-handle-energy"
              data-slider-handle
              role="slider"
              aria-valuemax={5}
              aria-valuemin={-5}
              aria-valuenow={this.props.energyLevel}
              aria-orientation="vertical"
            />
            <span className="slider-fill" data-slider-fill />
            <input type="hidden" />
          </div>
        </div>

        <div className="mood-meter-chart">
          <MoodMeterChart
            allowDragging
            updateEnergy={(energy) => this.updateEnergy(energy)}
            updatePleasantness={(pleasantness) => this.updatePleasantness(pleasantness)}
            mood={
              {
                energy: this.props.energyLevel,
                pleasantness: this.props.pleasantnessLevel,
              } as Mood
            }
          />
        </div>

        <div className="mm-slider-container mm-slider-container-horizontal">
          <div
            className="slider slider-pleasantness"
            data-slider
            data-start="-5"
            data-initial-start={this.props.pleasantnessLevel}
            data-end="5"
            data-step="1">
            <span
              className="slider-handle-pleasantness"
              data-slider-handle
              role="slider"
              aria-valuemax={5}
              aria-valuemin={-5}
              aria-valuenow={this.props.pleasantnessLevel}
              aria-orientation="horizontal"
            />
            <span className="slider-fill" data-slider-fill />
            <input type="hidden" />
          </div>
        </div>
      </div>
    )
  }
}

export default connector(MoodSection)
